var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"records-footer-wrapper"},[_vm._m(0),_c('div',{staticClass:"ercode"},[_vm._m(1),_c('span',[_vm._v(_vm._s(_vm.$tc('footprint.code')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/img/logo.png"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ercode-img"},[_c('img',{attrs:{"src":"","alt":""}})])
}]

export { render, staticRenderFns }